module.exports = __webpack_public_path__ + "img/card_ip_stipulation6163.bbd4c3ef.svg";